<template>
  <div class="sort-dropdown" v-click-outside="() => handleClickOutside()">
    <span class="sort-label">Sort By:</span>
    <button class="sort-button" @click="toggleDropdown">
      {{ selectedSort }} 
      <svg 
      class="arrow-icon" 
      :class="{ 'rotated': isDropdownVisible }"
      width="12.727539" height="7.778076" viewBox="0 0 12.7275 7.77808" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs/>
          <path id="Vector" d="M6.36 4.94L11.31 0L12.72 1.41L6.36 7.77L0 1.41L1.41 0L6.36 4.94Z" fill="#1D1D34" fill-opacity="1.000000" fill-rule="nonzero"/>
      </svg>

    </button>

    <ul v-if="isDropdownVisible" class="dropdown-menu">
      <li 
        v-for="(option, index) in sort" 
        :key="index" 
        @click="selectSort(option)"
      >
        {{ option.title }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sort: {
      type: Array,
      default: () => [],
    },
    data_name: String,
  },
  data() {
    return {
      selectedSort: 'Latest',  // Выбранный пункт по умолчанию
      isDropdownVisible: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    selectSort(option) {
      this.selectedSort = option.title;
      this.isDropdownVisible = false;
      this.$emit('update:modelValue', option.id);  // Отправка выбранного значения родителю
    },
    handleClickOutside(){
      this.isDropdownVisible = false;
    },
  },
};
</script>

<style scoped>
.sort-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.sort-label {
  color: rgb(86, 86, 95);
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
  text-wrap: nowrap;
}

.sort-button {
  display: flex;
  align-items: center;
  gap: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  /* Header/H4: 16px Medium */
  color: rgb(29, 29, 52);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: left;
}


.arrow-icon {
  transition: transform 0.3s ease;
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  list-style: none;
  padding: 0;
  margin-top: 4px;
  z-index: 10;
}

.dropdown-menu li {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
}

.dropdown-menu li:hover {
  background: #f0f0f0;
}
@media (max-width: 768px) {

}
</style>
